// Verification submit + admin decision schemas.
import { z } from 'zod';

import { idSchema, isoTimestampSchema, richTextSchema } from './common.js';

export const evidenceKindSchema = z.enum([
  'id_document',
  'selfie',
  'business_registration',
  'tax_id',
  'utility_bill',
]);
export type EvidenceKind = z.infer<typeof evidenceKindSchema>;

export const submitVerificationInputSchema = z.object({
  subject_kind: z.enum(['artist', 'host_user', 'venue']),
  subject_id: idSchema,
  evidence_urls: z.array(z.string().url()).min(1).max(8),
  evidence_kinds: z.array(evidenceKindSchema).min(1).max(8),
});
export type SubmitVerificationInput = z.infer<typeof submitVerificationInputSchema>;

export const adminApproveVerificationInputSchema = z.object({
  verification_id: idSchema,
  internal_notes: richTextSchema(2000).optional(),
  expires_at: isoTimestampSchema.optional(),
});
export type AdminApproveVerificationInput = z.infer<typeof adminApproveVerificationInputSchema>;

export const adminRejectVerificationInputSchema = z.object({
  verification_id: idSchema,
  rejection_reason: richTextSchema(1000).refine((s) => s.trim().length >= 10, {
    message: 'Give the subject a clear, specific reason they can act on.',
  }),
  internal_notes: richTextSchema(2000).optional(),
});
export type AdminRejectVerificationInput = z.infer<typeof adminRejectVerificationInputSchema>;

export const adminRevokeVerificationInputSchema = z.object({
  verification_id: idSchema,
  revocation_reason: richTextSchema(1000).refine((s) => s.trim().length >= 10, {
    message: 'Give the subject a specific reason for the revocation.',
  }),
  internal_notes: richTextSchema(2000).optional(),
});
export type AdminRevokeVerificationInput = z.infer<typeof adminRevokeVerificationInputSchema>;

export const adminDecideVerificationInputSchema = z.discriminatedUnion('decision', [
  z.object({ decision: z.literal('approve'), payload: adminApproveVerificationInputSchema }),
  z.object({ decision: z.literal('reject'), payload: adminRejectVerificationInputSchema }),
  z.object({ decision: z.literal('revoke'), payload: adminRevokeVerificationInputSchema }),
]);
export type AdminDecideVerificationInput = z.infer<typeof adminDecideVerificationInputSchema>;
